export const MANAGE_PPRTABLEDATA = "MANAGE_PPRTABLEDATA"
export const ISSUE_PPRTABLEDATA = "ISSUE_PPRTABLEDATA"
export const BUS_STATION = "BUS_STATION"
export const COUNTER_LIST = "COUNTER_LIST"
export const SKIP_PPRTABLEDATA = "SKIP_PPRTABLEDATA"
export const TRASFER_PPRTABLEDATA = "TRASFER_PPRTABLEDATA"


